// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.scroll-area {\n  position: relative;\n  margin: auto;\n  height: calc(100vh - 60px);\n  background-color: transparent !important;\n}\n", ""]);
// Exports
module.exports = exports;
